import { render, staticRenderFns } from "./user_basicInfo.vue?vue&type=template&id=13c6b9c4&scoped=true&"
import script from "./user_basicInfo.vue?vue&type=script&lang=js&"
export * from "./user_basicInfo.vue?vue&type=script&lang=js&"
import style0 from "./user_basicInfo.vue?vue&type=style&index=0&id=13c6b9c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c6b9c4",
  null
  
)

export default component.exports